import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next"
import './overlay.scss'
import { UploadButton } from './uploadButton'
import { ThirdPartyLibraryState } from '../ImageLibrary/types/ThirdPartyLibrary';
import { ACTIONS } from '../ImageLibrary/redux/actions';
import { setForceUploadOverlayOpen } from '../redux/actions/product';

export const UploadOverlay = ({fabricSize, partId}:any) => {

    const { t } = useTranslation()
    const currentImage = useSelector((state: any) => state.currentImg);
    const forceUploadOverlayOpen = useSelector((state: any) => state.forceUploadOverlayOpen);
    const mediaLibTitle = useSelector((state: any) => state.mediaLibTitle);
    const {id:categoryId, isOpenToUse} = useSelector(({thirdPartyLibrary}:{thirdPartyLibrary: ThirdPartyLibraryState}) => thirdPartyLibrary.rootCategory) || {};

    const [showUploadBanner, setUploadBannerVisible] = useState(true);

    const dispatch = useDispatch();

    const handleImageSelection = useCallback(()=>{
        dispatch(setForceUploadOverlayOpen(false))
        setUploadBannerVisible(false);
    },[])

    useEffect(()=>{
        !showUploadBanner && setUploadBannerVisible(true)
    },[forceUploadOverlayOpen])


    useEffect(()=>{
        setUploadBannerVisible(!currentImage && !mediaLibTitle && (!categoryId))
    }, [currentImage, mediaLibTitle, categoryId]);

    return (
        showUploadBanner?<div className='overlayPage'>
            <div className='overlayBody'>
                <div className='uploadOverlayBtnDiv'>
                    {/* <button className='uploadOverlayBtn'>Upload your design</button> */}
                    <UploadButton onImageSelected={handleImageSelection} 
                                  fabricSize={fabricSize} 
                                  partId={partId}
                                  isTileUpload={false} />
                </div>
                <div className='vrOverlay' />
                <div className='uploadOverlayDescPage'>
                    <div className='uploadDescriptionDiv'>
                        <div className='headerOverlayDiv'>{t("editor.custom.overlay_upload_your_design_header")}</div>
                        <div className='overlayDesc1'>
                            {t("editor.custom.overlay_upload_your_design_header_desc")}
                        </div>
                        <div className='hrOverlay' />
                        <div className='overlayDesc2'>
                            {t("editor.custom.overlay_upload_formats")}
                        </div>
                        <div className='overlayDesc3'>
                            {t("editor.custom.overlay_learn_how_to_link")}
                        </div>
                        <div className='hrOverlay' />
                        <div className='overlayCopyright'>{t("editor.custom.overlay_copyright_header")}</div>
                        <div className='overlayCWDesc'>
                            {t("editor.custom.overlay_copyright_desc")}
                        </div>
                    </div>
                </div>
            </div>
        </div>:null
    )
}
